import { FC, useState, useEffect, ReactNode } from 'react';

import { ArrowIcon, CaretContainer, LinkTxt, CaretTextContainer } from './caretBtn.sc';

interface OwnProps{
  open?: boolean;
  size?: string;
  caretColor?: string;
  withContainer?: boolean;
  maxWidth?: string;
  doNotSpinCaretOnClick?: boolean;
  children: ReactNode;
}

const CaretBtn: FC<OwnProps> = ({
                                  open = false,
                                  size = '1rem',
                                  caretColor,
                                  withContainer = false,
                                  maxWidth = '165px',
                                  doNotSpinCaretOnClick,
                                  children
}) => {
  const [isOpen, setIsOpen] = useState(open || false);
  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const caretClick = () => {
    if (!doNotSpinCaretOnClick) setIsOpen((open) => !open);
  };

  const Caret = (
    <CaretTextContainer
      $size={size}
      onClick={caretClick}
      $maxWidth={maxWidth}
      $isCursorDefault={doNotSpinCaretOnClick}
    >
      {children && <LinkTxt $noOverflow={maxWidth === 'none'}>{children}</LinkTxt>}
      <ArrowIcon $caretColor={caretColor} name="iconDropDownArrow" width={size} $open={isOpen} />
    </CaretTextContainer>
  );

  if (withContainer) {
    return <CaretContainer>{Caret}</CaretContainer>;
  }
  return Caret;
};

export default CaretBtn;
